/* ANGE Projects — mobile sticky Add to cart bar
   ANGE (Oct 2026, Anovair-style): the bar is HIDDEN on page load and only slides in once the
   real Add to cart button has been scrolled PAST (it is above the top of the screen). It hides
   again when the real button comes back into view, and while the site footer is in view.
   (Before Oct 2026 the bar was visible immediately on page load.)
   Mirrors label / disabled state and the live price, and proxies clicks to the real button so
   all existing variant validation and AJAX add-to-cart logic is reused as-is. The size
   selector opens its own panel in place and writes directly to the real underlying <select>.

   ANGE: price source. The price shown in the bar is taken from the price on the main Add to
   cart button (.product-form__submit-price), or, if that is empty, from the price next to the
   product title (.product__title-price). */
(function () {
  function initStickyAtc(root) {
    // Hidden from the very first frame, so it never flashes on load.
    root.classList.add('is-hidden');

    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var targetButtonId = root.dataset.targetButton;
    var targetButton = document.getElementById(targetButtonId);
    var titlePrice = document.querySelector('.product__title-price');
    var stickyButton = root.querySelector('[data-sticky-atc-button]');
    var stickyPrice = root.querySelector('.sticky-atc__price');
    var sizeRow = root.querySelector('[data-sticky-atc-size-row]');
    var stickySizeTrigger = root.querySelector('[data-sticky-atc-size]');
    var stickySizeLabel = root.querySelector('[data-sticky-atc-size-label]');
    var stickySizePanel = root.querySelector('[data-sticky-atc-size-panel]');
    var defaultAddLabel = stickyButton
      ? stickyButton.querySelector('span').textContent.trim()
      : 'Add to cart';

    if (!targetButton) return;

    function syncPrice() {
      if (!stickyPrice) return;
      var buttonPrice = targetButton.querySelector('.product-form__submit-price');
      var text = (buttonPrice && buttonPrice.textContent.trim()) || (titlePrice && titlePrice.textContent.trim()) || '';
      if (text && stickyPrice.textContent.trim() !== text) {
        stickyPrice.textContent = text;
      }
    }

    function syncButtonState() {
      if (!stickyButton) return;

      if (targetButton.hasAttribute('disabled')) {
        stickyButton.setAttribute('disabled', 'disabled');
      } else {
        stickyButton.removeAttribute('disabled');
      }

      var realLabelSpan = targetButton.querySelector('.product-form__submit-label');
      var stickyLabel = stickyButton.querySelector('span');
      if (stickyLabel) {
        stickyLabel.textContent = (realLabelSpan && realLabelSpan.textContent.trim())
          ? realLabelSpan.textContent
          : defaultAddLabel;
      }

      if (targetButton.classList.contains('button--secondary')) {
        stickyButton.classList.add('button--secondary');
        stickyButton.classList.remove('button--primary');
      } else {
        stickyButton.classList.add('button--primary');
        stickyButton.classList.remove('button--secondary');
      }

      var computed = window.getComputedStyle(targetButton);
      stickyButton.style.setProperty('background-color', computed.backgroundColor);
      stickyButton.style.setProperty('background-image', computed.backgroundImage);
      stickyButton.style.setProperty('color', computed.color);
      stickyButton.style.setProperty('border-color', computed.borderColor);
      stickyButton.style.setProperty('border-width', computed.borderWidth);
      stickyButton.style.setProperty('border-style', computed.borderStyle);

      syncPrice();
    }

    function getRealSelect() {
      return document.querySelector('.product-form__input--dropdown select');
    }

    function closeSizePanel() {
      if (!sizeRow || !stickySizePanel) return;
      sizeRow.classList.remove('is-open');
      stickySizePanel.hidden = true;
    }
    function openSizePanel() {
      if (!sizeRow || !stickySizePanel) return;
      sizeRow.classList.add('is-open');
      stickySizePanel.hidden = false;
    }

    function buildSizePanel() {
      var realSelect = getRealSelect();
      if (!stickySizePanel || !realSelect) return;
      stickySizePanel.innerHTML = '';
      Array.from(realSelect.options).forEach(function (opt) {
        if (!opt.value) return;
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'sticky-atc__size-option';
        if (opt.disabled) row.classList.add('is-disabled');
        row.textContent = opt.textContent.trim();
        row.addEventListener('click', function () {
          if (opt.disabled) return;
          realSelect.value = opt.value;
          realSelect.dispatchEvent(new Event('change', { bubbles: true }));
          closeSizePanel();
        });
        stickySizePanel.appendChild(row);
      });
    }

    function syncSizeLabelFromRealSelect() {
      var realSelect = getRealSelect();
      if (!stickySizeLabel || !realSelect) return;
      var opt = realSelect.options[realSelect.selectedIndex];
      stickySizeLabel.textContent = (opt && opt.value) ? opt.textContent.trim() : 'Select a Size';
      buildSizePanel();
    }

    if (stickySizeLabel) stickySizeLabel.textContent = 'Select a Size';
    syncButtonState();
    buildSizePanel();

    new MutationObserver(syncButtonState).observe(targetButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    if (titlePrice) {
      new MutationObserver(syncPrice).observe(titlePrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    var realSelectInit = getRealSelect();
    if (realSelectInit) {
      realSelectInit.addEventListener('change', syncSizeLabelFromRealSelect);
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        targetButton.click();
      });
    }

    if (stickySizeTrigger) {
      stickySizeTrigger.addEventListener('click', function () {
        if (stickySizePanel.hidden) {
          buildSizePanel();
          openSizePanel();
        } else {
          closeSizePanel();
        }
      });
      document.addEventListener('click', function (e) {
        if (sizeRow && !sizeRow.contains(e.target)) closeSizePanel();
      });
    }

    // Show ONLY when the real button has been scrolled past (above the screen) and the footer
    // is not in view.
    var scrolledPast = false;
    var footerInView = false;

    function updateVisibility() {
      if (scrolledPast && !footerInView) {
        root.classList.remove('is-hidden');
      } else {
        root.classList.add('is-hidden');
        closeSizePanel();
      }
    }

    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        });
        updateVisibility();
      },
      { threshold: 0 }
    );
    visibilityObserver.observe(targetButton);

    var footerEl = document.querySelector('footer.footer') || document.querySelector('footer');
    if (footerEl) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            footerInView = entry.isIntersecting;
          });
          updateVisibility();
        },
        { threshold: 0 }
      );
      footerObserver.observe(footerEl);
    }
  }

  document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
})();
